import { useQuery } from '@apollo/client';
import { GET_FORM_TEMPLATE_DATA } from '../../api/FormLibrary/queries';
import { FormTemplateData } from '../../api/FormLibrary/schema';

export interface UseFormTemplateOptions {
  formId: string;
  version: string;
  skip?: boolean;
}

export interface UseFormTemplateReturn {
  templateData: FormTemplateData | undefined;
  loading: boolean;
  error: Error | undefined;
  refetch: () => Promise<any>;
}

export const useFormTemplate = ({
  formId,
  version,
  skip = false,
}: UseFormTemplateOptions): UseFormTemplateReturn => {
  const { data, loading, error, refetch } = useQuery(GET_FORM_TEMPLATE_DATA, {
    variables: { FORM_ID: formId, VERSION: version },
    skip,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  return {
    templateData: data?.getFormTemplates?.[0],
    loading,
    error,
    refetch,
  };
};
